import { render } from "./Saldomodal.vue?vue&type=template&id=ef90d8e4"
import script from "./Saldomodal.vue?vue&type=script&lang=js"
export * from "./Saldomodal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\frontend.avicola\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__